import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { Box } from '@qga/roo-ui/components';
import { getMapLinkQueryString } from 'store/search/searchSelectors';
import { getQueryLocation } from 'store/router/routerSelectors';
import GoogleMapStaticWithShowMap from 'components/maps/GoogleMapStaticWithShowMap';
import { useDataLayer } from 'hooks/useDataLayer';
import AppLink from 'components/AppLink';

const StyledLink = styled(Box)`
  text-decoration: none;
  display: block;
  opacity: 0.8;
  transition: 400ms;
  &:hover {
    opacity: 1;
  }
`;

const MapButton = React.memo(() => {
  const { emitInteractionEvent } = useDataLayer();
  const location = useSelector(getQueryLocation);
  const queryString = useSelector(getMapLinkQueryString);
  const mapsLink = { pathname: '/search/map', search: queryString };

  const handleOnClick = useCallback(() => {
    emitInteractionEvent({ type: 'Show Map Button', value: 'Link Selected' });
  }, [emitInteractionEvent]);

  return (
    <StyledLink to={mapsLink} as={AppLink} onClick={handleOnClick} mb={4} minHeight={150} bg="greys.alto" variant="mobilePillButton">
      <GoogleMapStaticWithShowMap location={location} width={324} height={150} />
    </StyledLink>
  );
});

MapButton.displayName = 'MapButton';

export default MapButton;
